<template>
    <div class="user-filters">
      <div v-for="filter in projectFiltersList">
        <header @click="toggleFilterList(filter)">
          <h2>{{filter.name}}</h2>
          <div
            v-if="!isDesktop"
            class="total-and-toggle"
          >
            <span class="total"></span>
            <DropdownArrow :ascending="filter.showList"/>
          </div>
        </header>
        <div v-show="filter.showList">
          <Checkbox
            v-for="value in filter.values"
            :key="value"
            :value="value"
            :isChecked="isFilterChecked(filter, value)"
            @updateValue="$emit('updateUserFilters', updateUserFilters(filter, value))"
          />
        </div>
      </div>
    </div>
</template>

<script>
import Checkbox from '@/components/form-elements/Checkbox'
import DropdownArrow from '@/components/assets/DropdownArrow';

export default {
  name: "UserFilters",
  components: {
    DropdownArrow,
    Checkbox
  },
  props: {
    projectFilters: {
      type: Array
    },
    userFilters: {
      type: Array,
      default: () => []
    },
    isDesktop: {
      type: Boolean
    }
  },
  computed: {
    projectFiltersList() {
      if (this.projectFilters) {
        const projectFiltersWithShowList = this.projectFilters
        projectFiltersWithShowList.forEach((filter) => this.$set(filter, 'showList', this.isDesktop))
        return projectFiltersWithShowList
      }
    }
  },
  methods: {
    updateUserFilters(selectedFilter, selectedValue) {
      if (this.findUserFilter(selectedFilter)) {
        return this.updateExistingUserFilter(selectedFilter, selectedValue)
      } else {
        return this.addUserFilter(selectedFilter, selectedValue)
      }
    },
    updateExistingUserFilter(selectedFilter, selectedValue) {
      this.userFilters.forEach((filter, index, object) => {
        if (filter.name === selectedFilter.name) {
          this.updateValues(filter, selectedValue)
          if (filter.values.length === 0) {
            object.splice(index, 1)
          }
        }
      })
      return this.userFilters
    },
    addUserFilter(selectedFilter, selectedValue) {
      const newFilter = {
        name: selectedFilter.name,
        values: [selectedValue]
      }
      this.userFilters.push(newFilter)
      return this.userFilters
    },
    updateValues(filter, selectedValue) {
      if (filter.values.includes(selectedValue)) {
        filter.values = filter.values.filter(value => value !== selectedValue)
      } else {
        filter.values.push(selectedValue)
      }
      return filter
    },
    isFilterChecked(filter, value) {
      if (this.userFilters) {
        const userFilter = this.findUserFilter(filter)
        return (userFilter && userFilter.values)
          ? userFilter.values.includes(value)
          : false
      }
    },
    findUserFilter(selectedFilter) {
      return this.userFilters.find(filter => filter.name === selectedFilter.name)
    },
    toggleFilterList(selectedFilter) {
      if (!this.isDesktop) {
        this.projectFiltersList.find((filter) => {
          if (filter.name === selectedFilter.name) {
            filter.showList = !filter.showList
          }
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../assets/styles/colors';
@import '../../assets/styles/mixin';

.user-filters {
  border-bottom: 1px solid $primary-shadow;
  padding-bottom: 16px;

  h2 {
    color: $gd-black;
  }
}

header {
  @include flex(row, space-between, center);
  margin: 20px 0 12px 0;
  cursor: pointer;
}

.total-and-toggle {
  @include flex(row, center, center);

  .total {
    margin-right: 12px;
    color: $gd-dark-gray;
  }
}

.active-filters-container {

  .user-filters {
    border-bottom: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/user/UserFilters.vue